import { mapActions, mapGetters, mapState } from 'vuex'
import { PAYMENT_SERVICE_TYPE } from '@/base/const/payment.const'
import { Raven } from 'vue-raven'
import { MobileAppClass } from '@/base/class/mobileApp.class'
import { ToolsClass } from '@/base/class/tools.class'
import { PaymentClass } from '@/base/class/payment.class'
import { PAYWAY_GROUPS_TYPES } from '@/base/const/payway.const'
import { PaymentFee } from '@/base/class/paymentFee.class'

export default {
  props: {
    transaction: {
      type: Object | null,
      required: false
    },
    dccDetails: {
      type: Object | null,
      required: false
    },
    visibility: {
      type: Object | null,
      required: false
    },
    showButton: {
      type: Boolean,
      required: false
    },
    payway: {
      type: Object | null,
      required: false
    },
    isPaywall: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      returnUrl: state => state.payment.paymentData.returnUrl,
      isPaywallView: state => state.payment.paywallView,
      isServiceTypeMwf: state => {
        let serviceType = ''
        if (state.payment.paymentData && state.payment.paymentData.serviceType) {
          serviceType = state.payment.paymentData.serviceType
        }
        if (state.confirmation.data && state.confirmation.data.serviceType) {
          serviceType = state.confirmation.data.serviceType
        }
        return serviceType === PAYMENT_SERVICE_TYPE.mwf
      },
      isProductCartSet: state => !!state.payment.paymentData?.visibilityOptions?.showFrontBasket,
      expandFrontTransactionDetails: state => !!state.payment.paymentData?.visibilityOptions?.expandFrontTransactionDetails,
      selectedPaywayGroupType: state => state.payment.selectedPaywayGroupType,
      selectedPaywayGroupId: state => state.payment.selectedPaywayGroupId,
      paywayID: state => state.payment.form.paywayID
    }),
    ...mapGetters({
      paywayList: 'getPaywayList',
      groupList: 'getPaymentGroupList'
    }),
    allowReject: function () {
      return this.isPaywallView
    },
    activePayway: function () {
      if (!this.paywayID) {
        return null
      }
      return this.paywayList.find(payway => payway.id === this.paywayID)
    },
    isBlikAuto: function () {
      return this.selectedPaywayGroupType === PAYWAY_GROUPS_TYPES.blikAuto && !!this.activePayway
    },
    selectedGroup: function () {
      if (!this.selectedPaywayGroupId) {
        return null
      }
      return this.groupList.find(group => group.id === this.selectedPaywayGroupId)
    },
    selectedPayway: function () {
      if (!this.paywayID) {
        return null
      }
      return this.paywayList.find(payway => payway.id === this.paywayID)
    }
  },
  methods: {
    ...mapActions([
      'sendPaymentRejectTrx'
    ]),
    /**
     * @param {string} returnUrl
     */
    goBackToShop (returnUrl) {
      if (ToolsClass.isMobileAppConnection()) {
        MobileAppClass.callMobileTransactionFinish()
        return
      }
      ToolsClass.goToExternalUrl(returnUrl)
    },
    sendPaymentReject () {
      this.sendPaymentRejectTrx()
        .then(returnUrl => {
          ToolsClass.goToExternalUrl(returnUrl)
        })
        .catch(error => {
          MobileAppClass.callMobileTransactionFinish()
          Raven.captureMessage('sendPaymentReject Method response error', {
            extra: error
          })
        })
    },
    getPaywayImage (payway) {
      return PaymentClass.getPaywayImage(payway)
    },
    getTransactionPayAmount () {
      if (this.dccDetails) {
        return Number(this.dccDetails.dcc.amount)
      }
      // jeśli mamy widok paywalla (inny niż confirmation) i mechanizm prowizji jest włączony (w nowym trybie indywidualnym)
      if (!PaymentFee.isConfirmationView() && PaymentFee.isPaymentFeeActive() && !PaymentFee.isPaymentFeeLegacyMode()) {
        // jeśli jedna stawka prowizji - doliczamy prowizję do kwoty płatności
        if (!PaymentFee.isPaymentFeeDifferent()) {
          return Number(this.transaction?.payAmount) + Number(PaymentFee.getPaymentFeeAsSingleValue())
        }
        // jeśli różne stawki prowizji i mamy wybrany kanał płatności - doliczamy prowizję do kwoty płatności
        if (PaymentFee.isPaymentFeeDifferent() && this.selectedPayway) {
          return Number(this.transaction?.payAmount + PaymentFee.getPaymentFeeForPaywayAsNumber(this.selectedPayway))
        }
      }
      // zwracamy czystą kwotę transakcji, bez doliczonej prowizji
      return Number(this.transaction?.payAmount)
    },
    getTransactionPayCurrency () {
      if (this.dccDetails) {
        return this.dccDetails.dcc.currency
      }
      return this.transaction?.payAmountCurrency
    },
    getTransactionOryginalAmount () {
      if (this.dccDetails) {
        return this.dccDetails.transaction.amount
      }
    },
    getTransactionOryginalCurrency () {
      if (this.dccDetails) {
        return this.dccDetails.transaction.currency
      }
    },
    getTransactionDccRate () {
      if (this.dccDetails) {
        return this.dccDetails.dcc.rate
      }
    },
    getTransactionCustomerFee () {
      if (this.dccDetails) {
        return this.dccDetails.dcc.marginPercentage
      }
      return this.transaction?.customerFee
    },
    formatOrderIdForScreenReader (orderId) {
      if (!orderId) return ''
      return String(orderId).split('').join(' ')
    }
  }
}
